export const buriedPoint = {
  TYPE_visit: '1', // 访问 (前)
  TYPE_login: '2', // H5登录 (前)
  TYPE_token_login: '3', // TOKEN登录 (前)
  TYPE_phone: '4', // 输入手机号 (前)
  TYPE_code: '5', // 发送验证码 (前)
  TYPE_money: '6', // 贷款金额大于2w (前)
  TYPE_capital_visit: '7', // 留资页访问 (前)
  TYPE_capital_submit: '8', // 留资页提交 (前)
  TYPE_capital_over: '10', // 留资页完成 (前)
  TYPE_capital_back: '11', // 留资页拦截 (前)
  TYPE_capital_download: '12', // 留资-下载 (前)
  TYPE_result_visit: '15', // 结果页 (前)
  TYPE_download_visit: '17', // 下载页 (前)
  TYPE_LANDING_VISIT: 'LANDING_VISIT', //落地页访问
  TYPE_H5_RETENTION_PAGE_VISIT: 'H5_RETENTION_PAGE_VISIT', //留资页访问
  TYPE_TOKEN_LOGIN: 'TOKEN_LOGIN', //token登录
  TYPE_H5_MATCH_SUCCESS: 'H5_MATCH_SUCCESS', //(钱包匹配成功)
};

export const codePage = {
  TYPE_ACCESS: '1', // 访问记录
  TYPE_INPUT_CLICK: '200', // 输入框点击
  TYPE_PHONE_NUMBER_INPUT: '2', // 手机号输入
  TYPE_GET_CODE: '3', // 验证码获取 true
  TYPE_INPUT_CODE: '500', // 验证码输入
  TYPE_CLICK_REGIST: '10', // 下一步按钮 true
  TYPE_FIND_GUEST_AUTH: '4', // 留资页基础信息补充信息 true (如果只有一个留资页的就用700)
  TYPE_FIND_BASE_INFO: '6', // 800留资页补充信息 true (最后一页)
  TYPE_FIND_GUEST_RETENTION_APPLY: '9', // 立即申请按钮 true
  TYPE_FIND_GUEST_AUTH_SUCCESS: '11', // 留资成功
  TYPE_FIND_GUEST_AUTH_FAIL: '1100', // 留资失败
  TYPE_FIND_ASSET_INFO: '8', // 1200,留资页基础信息补充信息第四版中间的一页 (中间页,不管第四版) 点下一步按钮触发的
  TYPE_FIND_LOAN_INFO_BTN: '7', // 留资页第一个页面按钮埋点(loanInfo)
  TYPE_FIND_ASSET_INFO_PAGE: '5', // 留资页的第二个页面埋点(assetInfo)
  TYPE_FIND_DO_INPUT: '2', // 触发手机输入框
  TYPE_RESULT_RECOMMENDED: '12', // 留资结果页有推荐产品人数
  TYPE_RESULT_SUBMITAUDIT: '13', // 留资结果页点击提交审核下款人数
  TYPE_RESULT_PUSHSUCCESS: '14', // 留资结果页推送订单成功数
  TYPE_RESULT_GOBACKCLICK: '15', // 留资结果页返回弹窗下载点击数
  TYPE_XINYU_DUOTUINUM: '20', // 信鱼使用 -多推人数
  TYPE_XINYU_DUOTUICLICKNUM: '21', // 信鱼使用 -多推人数点击
  TYPE_TOKEN_LOGIN: '24', // token登录
  TYPE_JS_RECOMMENDEDPAGE_UV: '25', // 极速版推荐页UV
  TYPE_JS_APPLYORDER: '26', // 极速版申请订单
  TYPE_LJ_DOWNLOAD_UV: '27', // 拦截-下载UV
  TYPE_ZC_DOWNLOAD_UV: '28', // 注册-下载UV
  TYPE_LZ_DOWNLOAD_UV: '29', // 留资-下载UV
  TYPE_RESULT_MORE_2W_MODAL_CLICK: '30', // 多推留资结果页 - 申请金额大于2万 - 弹窗点击申请产品
};
import baseImg from '@/assets/img/result/saas_product_logo.png';
export const baseImgUrl = {
  // baseImgUrl: 'https://picture.youkawallet.com/',
  baseImgUrl: 'https://picture.youkawallet.com/',
  jointUrlWallet(url: string) {
    /*switch (import.meta.env.VITE_USER_NODE_ENV) {
      case 'production':
        baseImgUrl.baseImgUrl = 'https://picture-pro.usurong.com';
        break;
      case 'test':
        baseImgUrl.baseImgUrl = 'https://picture-test.usurong.com/';
        break;
      default:
        baseImgUrl.baseImgUrl = 'https://picture-dev.usurong.com/';
    }*/
    if (url == undefined || url == '' || url == null || url == 'null' || url == 'undefined') {
      return baseImg;
    } else if (url.indexOf('http') > -1) {
      return url;
    } else {
      return baseImgUrl.baseImgUrl + url;
    }
  },
};

export const baseImgUrlYsr = {
  baseImgUrl: '',
  jointUrlWallet(url: string) {
    switch (import.meta.env.VITE_USER_NODE_ENV) {
      case 'production':
        baseImgUrl.baseImgUrl = 'https://picture-pro.youhangjh.com/';
        break;
      case 'test':
        baseImgUrl.baseImgUrl = 'https://picture-test.youhangjh.com/';
        break;
      default:
        baseImgUrl.baseImgUrl = 'https://picture-test.youhangjh.com/';
    }
    if (url == undefined || url == '' || url == null || url == 'null' || url == 'undefined') {
      return baseImg;
    } else if (url.indexOf('http') > -1) {
      return url;
    } else {
      return baseImgUrl.baseImgUrl + url;
    }
  },
  jointUrlNoWallet(url: string) {
    switch (import.meta.env.VITE_USER_NODE_ENV) {
      case 'production':
        baseImgUrl.baseImgUrl = 'https://picture-pro.youhangjh.com/';
        break;
      case 'test':
        baseImgUrl.baseImgUrl = 'https://picture-test.youhangjh.com/';
        break;
      default:
        baseImgUrl.baseImgUrl = 'https://picture-test.youhangjh.com/';
    }
    if (url.indexOf('http') > -1) {
      return url;
    } else {
      return baseImgUrl.baseImgUrl + url;
    }
  },
};

/**
 * S 返回拦截弹窗的埋点
 * */
export const gobackModalCode = {
  TYPE_MODAL_ONE_VISIT: 1, // 留资1弹窗访问PV/UV
  TYPE_MODAL_ONE_BTN1: 2, // 留资1弹窗按钮一PV/UV
  TYPE_MODAL_ONE_BTN2: 3, // 留资1弹窗按钮二PV/UV
  TYPE_MODAL_ONE_CLOSE: 4, // 留资1弹窗关闭PV/UV

  TYPE_MODAL_TWO_VISIT: 5, // 留资2弹窗访问PV/UV
  TYPE_MODAL_TWO_BTN1: 6, // 留资2弹窗按钮一PV/UV
  TYPE_MODAL_TWO_BTN2: 7, // 留资2弹窗按钮二PV/UV
  TYPE_MODAL_TWO_CLOSE: 8, // 留资2弹窗关闭PV/UV

  TYPE_MODAL_RESULT_VISIT: 9, // 结果页弹窗访问PV/UV
  TYPE_MODAL_RESULT_BTN: 10, // 结果页弹窗下载PV/UV
  TYPE_MODAL_RESULT_CLOSE: 11, // 结果页弹窗关闭PV/UV

  TYPE_RESULT_VISIT: 12, // 结果页访问PV/UV
  TYPE_RESULT_DOWNLOAD: 13, // 结果页下载PV/UV
  TYPE_RESULT_CLOSE: 14, // 结果页关闭PV/UV

  TYPE_RESULT_DOWNLOAD_VISIT: 15, // 留资下载页访问PV/UV
  TYPE_RESULT_DO_DOWNLOAD: 16, // 留资下载页下载PV/UV
  TYPE_RESULT_REGISTER_DOWNLOAD: 17, // 注册下载页访问PV/UV
  TYPE_RESULT_REGISTER_DO_DOWNLOAD: 18, // 注册下载页下载PV/UV
};
export const addNewCodePage = {
  TYPE_NAME: 1, // 输入姓名后
  TYPE_IDCARD: 2, // 输入身份证后
  TYPE_RESERVED_SUCCESS: 3, // 成功页面的埋点次数
  TYPE_CANCEL_APPLY: 4, // 取消申请
  TYPE_PHONE_INPUT: 5, // 手机输入后
  TYPE_SUBMIT: 6, // 留资提交按钮
};

/** 留资状态*/
export const tagStatus = {
  basicsInfo: 100 /* h5获客基本信息*/,
  companySlaves: 200 /* h5获客上班族、公务员*/,
  professions: 300 /* h5获客自由职业者、其他*/,
  owners: 400 /* 企业主*/,
  person: 500 /* 个体户*/,
  loanApplication: 600 /* 申请借款*/,
  profession: 1000 /* 职业类别*/,
  loanMonth: 1200 /* 贷款月份*/,
};

export const riFormType = {
  addressSelect: 'riAddressSelect',
  input: 'riInput',
  select: 'riSelect',
};

export const projectName = '小荷花';

export const AppInfo = {
  name: projectName,
  company: '成都优航信息科技有限公司',
  icp: '蜀ICP备2022018105号-6',
  version: '1.0.0',
};

export const blackOnlineAgreement = [
  { name: '《贷款知情确认书》', url: 'https://protocol-pro.youhangjh.com/agreement/1113/dkzqqrs.html' },
  { name: '《个人信息对外提供授权书》', url: 'https://protocol-pro.youhangjh.com/agreement/1113/grxxdwtgsqs.html' },
];
